export default __webpack_public_path__ + "static/media/04AW1APR66.4e6c22df.jpg";